import { render, staticRenderFns } from "./adduserAgreement.vue?vue&type=template&id=93e44732&scoped=true&"
import script from "./adduserAgreement.vue?vue&type=script&lang=js&"
export * from "./adduserAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e44732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93e44732')) {
      api.createRecord('93e44732', component.options)
    } else {
      api.reload('93e44732', component.options)
    }
    module.hot.accept("./adduserAgreement.vue?vue&type=template&id=93e44732&scoped=true&", function () {
      api.rerender('93e44732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/adduserAgreement.vue"
export default component.exports